<mat-card>
  <mat-toolbar>
    {{ 'clientsSocisList.titol' | translate }}
    <span class="fill-remaining-space"></span>
    <div style="width:100%;float:right">
      <button mat-icon-button matTooltip="{{ 'clientsSocisList.exportToolTip' | translate }}" attr.aria-label="{{ 'clientsSocisList.exportToolTip' | translate }}" matTooltipClass="tooltip-style" (click)="exportar()" style="float: right; margin-right: 0">
        <mat-icon color="primary" style="font-size:24px">vertical_align_bottom</mat-icon>
      </button>
      <button mat-icon-button style="float: right; width:70px; margin-right: 0" (click)="addClientSoci()" matTooltip="{{ 'clientsSocisList.nova' | translate }}" attr.aria-label="{{ 'clientsSocisList.nova' | translate }}" matTooltipClass="tooltip-style">
          <mat-icon color="primary" style="font-size:24px">add</mat-icon>
      </button>
      <button mat-icon-button matTooltip="{{ 'clientsSocisList.filtre' | translate }}" attr.aria-label="{{ 'clientsSocisList.filtre' | translate }}" matTooltipClass="tooltip-style" (click)="toggleFiltersVisibility()" style="float: right; margin-right: 0">
        <mat-icon color="primary" style="font-size:24px">filter_list</mat-icon>
      </button>
    </div> 
  </mat-toolbar>
  <mat-card-content>
    <mcrit-gestio-clientssocis-filters
     *ngIf="showFilters"
     [validFilters]="clientsSocisFilters"
     (changeFilter)="computeActiveFilters($event)">
    </mcrit-gestio-clientssocis-filters>
    <table>
      <thead>
        <tr>
          <th></th>
          <th *ngFor="let field of tableFields" (click)="cycleOrdering(field[0])" style="vertical-align: top">
            {{field[1]}}
            <mat-icon style="vertical-align: middle">
              {{(
                orderingParameters[field[0]] === 1 ?
                'keyboard_arrow_up' :
                  (orderingParameters[field[0]] === 2 ?
                  'keyboard_arrow_down' : '')
               )}}
            </mat-icon>
          </th>
        </tr>
      </thead>
      <tbody *ngIf="clientsSocisData">
        <tr *ngFor="let clienstsocis of clientsSocisData.rows;" style="cursor:pointer" (click)="editClientSoci(clienstsocis)">
          <td>
            <button mat-icon-button style="float: right; width:70px; margin-right: 0" (click)="deleteClientSoci($event,clienstsocis.id)" matTooltip="{{ 'clientsSocisList.esborrarToolTip' | translate }}" attr.aria-label="{{ 'clientsSocisList.esborrarToolTip' | translate }}" matTooltipClass="tooltip-style">
                <mat-icon color="primary" style="font-size:24px">delete</mat-icon>
            </button>
          </td>
          <td *ngFor="let field of tableFields;let i = index">
            <div style="float: left;clear: none;padding-right: 5px">{{clienstsocis[field[0]]}}</div>
          </td>
        </tr>
      </tbody>
    </table>
  </mat-card-content>
  <mat-toolbar class="footer">
    <span class="fill-remaining-space"></span>
    <span style="padding-right: 1em">
      {{ 'clientsSocisList.liniesPag' | translate }}: {{listClientsSocisService.rowsPerPage}}
      <button mat-icon-button [mat-menu-trigger-for]="menuNumberRows">
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
    </span>
    <span style="padding-right: 1em" *ngIf="clientsSocisData">
      {{ 'clientsSocisList.registresMostrats' | translate:{ first: firstRegisterShown, last: lastRegisterShown, total: clientsSocisData.registers } }}
    </span>
    <button mat-icon-button (click)="gotoPage(0)">
      <mat-icon>first_page</mat-icon>
    </button>
    <button mat-icon-button (click)="requestPrevious()">
      <mat-icon>keyboard_arrow_left</mat-icon>
    </button>
    <button mat-icon-button (click)="requestNext()">
      <mat-icon>keyboard_arrow_right</mat-icon>
    </button>
  </mat-toolbar>
</mat-card>
<mat-menu #menuNumberRows y-position="above">
    <button mat-menu-item *ngFor="let value of rowsPerPageOptions" (click)="setRowPerPage(value)">{{value}}</button>
</mat-menu>
